import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeFormat from "../selectedDateRange/timeFormat.js";
export default {
  name: 'selectedDateRange',
  props: {
    // 日期选择中间间隔符
    separator: {
      type: String,
      default: '至'
    },
    // 选择框的大小
    size: {
      type: String,
      default: 'large'
    },
    // 开始时间
    startDateTime: {
      type: String,
      default: ''
    },
    // 开始时间
    endDateTime: {
      type: String,
      default: ''
    },
    // 开始禁止时间
    startDisableDateTime: {
      type: Date,
      default: null
    },
    // 结束禁止时间
    endDisableDateTime: {
      type: Date,
      default: null
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 显示格式
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    // 选择框的宽度
    width: {
      type: String,
      default: '205'
    },
    // 间隔时间
    intervalHours: {
      type: Number,
      default: 0
    },
    firstDayOfWeek: {
      type: Number,
      default: 7
    }
  },
  computed: {
    start: {
      get: function get() {
        if (!this.startDateTime) {
          return '';
        } else if (new Date(this.startDateTime) == 'Invalid Date') {
          return '';
        }
        return new Date(this.startDateTime);
      },
      set: function set(val) {
        if (this.end) {
          if (this.intervalHours != 0) {
            var value = new Date(val);
            this.$emit('update:endDateTime', value ? timeFormat(value.setHours(value.getHours() + this.intervalHours), 'yyyy-mm-dd hh:MM:ss') : value);
          } else {
            if (this.end.getTime() < val.getTime()) {
              this.$emit('update:endDateTime', val ? timeFormat(val.getTime(), 'yyyy-mm-dd hh:MM:ss') : val);
            }
          }
        } else {
          this.$emit('update:endDateTime', val ? timeFormat(val.getTime(), 'yyyy-mm-dd hh:MM:ss') : val);
        }
        this.$emit('update:startDateTime', val ? timeFormat(val.getTime(), 'yyyy-mm-dd hh:MM:ss') : val);
        this.$emit('change');
      }
    },
    end: {
      get: function get() {
        if (!this.endDateTime) {
          return '';
        } else if (new Date(this.endDateTime) == 'Invalid Date') {
          return '';
        }
        return new Date(this.endDateTime);
      },
      set: function set(val) {
        if (val.getTime() < new Date(this.startDateTime).getTime()) {
          this.$emit('update:endDateTime', this.startDateTime);
          this.$emit('change');
          return;
        }
        this.$emit('update:endDateTime', val ? timeFormat(val.getTime(), 'yyyy-mm-dd hh:MM:ss') : val);
        this.$emit('change');
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      startOptions: {
        disabledDate: function disabledDate(date) {
          if (!_this.startDisableDateTime && !_this.endDisableDateTime) {
            return false;
          }
          if (_this.startDisableDateTime && !_this.endDisableDateTime) {
            return !(date.setHours(0, 0, 0, 0) >= _this.startDisableDateTime.setHours(0, 0, 0, 0));
          }
          if (!_this.startDisableDateTime && _this.endDisableDateTime) {
            return !(date.setHours(0, 0, 0, 0) <= _this.endDisableDateTime.setHours(0, 0, 0, 0));
          }
          if (_this.startDisableDateTime && _this.endDisableDateTime) {
            return !(date.setHours(0, 0, 0, 0) >= _this.startDisableDateTime.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= _this.endDisableDateTime.setHours(0, 0, 0, 0));
          }
        },
        firstDayOfWeek: this.firstDayOfWeek
      },
      endOptions: {
        disabledDate: function disabledDate(date) {
          if (!_this.endDisableDateTime && !_this.start) {
            return false;
          }
          if (_this.endDisableDateTime && !_this.start) {
            return !(date.setHours(0, 0, 0, 0) <= _this.endDisableDateTime.setHours(0, 0, 0, 0));
          }
          if (!_this.endDisableDateTime && _this.start) {
            return !(date.setHours(0, 0, 0, 0) >= _this.start.setHours(0, 0, 0, 0));
          }
          if (_this.endDisableDateTime && _this.start) {
            return !(date.setHours(0, 0, 0, 0) >= _this.start.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= _this.endDisableDateTime.setHours(0, 0, 0, 0));
          }
        },
        firstDayOfWeek: this.firstDayOfWeek
      }
    };
  }
};